import script from "./CampaignTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignTable.vue?vue&type=script&setup=true&lang=js"

import "./CampaignTable.vue?vue&type=style&index=0&id=05c736b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c736b8"]])

export default __exports__